<template>
    <div>
    <b-field class="commonrules-grp"  label="Flight within the U.S. when the total cost is above $ ">
        <b-input type="number" class="cstmb-input" v-model="domesticAirFareCap" @input="$emit('domesticAirFareCap',domesticAirFareCap)"/>
    </b-field></div>
</template>
<script>
export default{
    name : "DomesticAirFareCap",
    props:{ demesticAirFare : null},
    data(){
        return{
            domesticAirFareCap : null
        }
    },
    mounted() {
        this.domesticAirFareCap = this.demesticAirFare;
    }
}
</script>